module.exports = __webpack_public_path__ + "2a9ee93e2993d242af63c7e404d09137.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/uikit/assets/font/noto-sans-kr-v11-korean_latin-900.woff2
// module id = 462
// module chunks = 0